module.exports = __webpack_public_path__ + "img/EC.406ea0ac.svg";